export default __webpack_public_path__ + "static/media/clash-of-clans@2x.32e16a9f.webp";